<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-sm-12">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">Role List</h4>
                  </div>
               </div>
    
               <div class="card-body">
                  <div class="table-responsive">
                     <div class="row justify-content-between">
                        <div class="col-10 col-sm-10 col-md-6">
                           <!-- <div id="user_list_datatable_info" class="dataTables_filter">
                              <form class="mr-3 position-relative">
                                 <div class="form-group mb-0">
                                    <input type="text" v-model="search" class="form-control" placeholder="Search" aria-controls="user-list-table">
                                 </div>
                              </form>
                           </div> -->
                        </div>
                        <div class="d-flex flex-row-reverse align-items-center col-2 col-sm-2 col-md-6">
                           <b-button variant="outline-primary" class="mx-2 border-none d-flex align-items-center" v-on:click="redirectAdd"><i class="las la-plus-square h4 m-0 p-0"></i></b-button>
                        </div>
                     </div>

                     <data-tables-server :data="roles" :total="dataCount" @size-change="handleSizeChange" @current-page-change="handleCurrentChange">
                        <el-table-column prop="id" label="ID" width="70" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.id}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="name" label="Name" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.name}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="description" label="Description" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.description}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="action" label="Action" width="150" header-align="center" align="center">
                           <template scope="scope">
                              <a class="iq-bg-primary" v-b-tooltip.top title="Edit" href="javascript:void(0);" v-on:click="redirectEdit(scope.row.id)"><i class="ri-pencil-line mr-1"></i></a>
                                 <a class="iq-bg-primary" v-b-tooltip.top title="Delete" href="javascript:void(0);" v-on:click="deleteRecord(scope.row.id)"><i class="ri-delete-bin-line mr-1"></i></a>
                           </template>
                        </el-table-column>
                     </data-tables-server>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

const config = require("../../../../../config");
locale.use(lang)

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(DataTablesServer)

export default {
   name:'RoleList',
   data() {
      return {
         roles: [],
         dataCount: null,
         search: '',
         delForm: {
            id:''
         },
         currentPage: 1,
         pageSize: 20,
         order: {
            column: null,
            order: null
         }
      }
   },
   mounted: async function() {
      await this.getData();
   },
   methods: {
      getData: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/roles', {
               params: {
                  m: this.$route.meta.uid,
                  pageno: this.currentPage,
                  limit: this.pageSize,
                  ordercolumn: this.order.column,
                  order: this.order.order
               }
            });
            this.roles = res.data.rows;
            this.dataCount = res.data.count;
         } catch(error) {
            alert("Error: Unable to retrieve role data");
            console.log("Error: ", error)
         }
      },
      redirectEdit: async function(roleId) {
         this.$router.push({path: '/role/edit/' + roleId});
      },
      deleteRecord: async function(roleId) {
         try {
            if(confirm("Are you sure you want to delete this record?")) {
               this.delForm.id = roleId;
               await axios.post(config.api.URL + '/api/roles/delete', this.delForm, { params: { m: this.$route.meta.uid } });
               
               this.getData();
               alert("Record deleted.");
            }
         } catch(error) {
            alert("Error: Delete role unsuccessful.");
            console.log("Error:", error);
         }
      },
      redirectAdd: async function() {
         this.$router.push({path: '/role/add'});
      },
      handleSizeChange: async function(val) {
         this.pageSize = val;
         await this.getData();
      },
      handleCurrentChange: async function(val) {
         this.currentPage = val;
         await this.getData();
      }
   }
}
</script>